import { createIcon } from '@chakra-ui/react';

export const GridIcon = createIcon({
  displayName: 'GridIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M0 10.6667H10.6667V0H0V10.6667ZM2.66667 2.66667H8V8H2.66667V2.66667Z"
        fill="#27273A"
      />
      <path
        d="M0 24.0007H10.6667V13.334H0V24.0007ZM2.66667 16.0007H8V21.334H2.66667V16.0007Z"
        fill="#27273A"
      />
      <path
        d="M13.334 0V10.6667H24.0007V0H13.334ZM21.334 8H16.0007V2.66667H21.334V8Z"
        fill="#27273A"
      />
      <path d="M24.0007 21.334H21.334V24.0007H24.0007V21.334Z" fill="#27273A" />
      <path d="M16.0007 13.334H13.334V16.0007H16.0007V13.334Z" fill="#27273A" />
      <path d="M18.6667 16H16V18.6667H18.6667V16Z" fill="#27273A" />
      <path d="M16.0007 18.666H13.334V21.3327H16.0007V18.666Z" fill="#27273A" />
      <path d="M18.6667 21.334H16V24.0007H18.6667V21.334Z" fill="#27273A" />
      <path d="M21.3327 18.666H18.666V21.3327H21.3327V18.666Z" fill="#27273A" />
      <path d="M21.3327 13.334H18.666V16.0007H21.3327V13.334Z" fill="#27273A" />
      <path d="M24.0007 16H21.334V18.6667H24.0007V16Z" fill="#27273A" />
    </svg>
  ),
});
